<template>
  <Navbar></Navbar>
  <div class="product-detail-page">
    <div class="detail-banner">
      <div class="img-box detail-banner-img"><img src="/assets/product/engine/6Z30/6Z30.jpg" alt=""></div>
      <div class="detail-banner-r">
        
        <div class="detail-banner-t2">6Z30 双涡轮增压V型6缸发动机</div>
        <div class="detail-banner-desc">
          <!-- 中国自主首款双涡轮增压V型6缸发动机；<br /> -->
          稳定高效燃烧系统、GDI+PFI燃油双喷系统、双VGT增压器、多功能进气系统、高强度曲柄连杆系统、双排链配气正时、整机NVH开发、精准调控技术。
        </div>
      </div>
    </div>

    <div class="detail-box">
      <div class="detail-title">强动力</div>
      <div class="detail-utils">
        <div class="detail-utils-item">
          <div class="detail-utils-d">排量（L）</div>
          <div class="detail-utils-u">2.993</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">最大净功率（kW/rpm）</div>
          <div class="detail-utils-u">260/6000</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">最大净扭矩（N·m/rpm）</div>
          <div class="detail-utils-u">500/1500~4500</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">低速扭矩（N·m/rpm）</div>
          <div class="detail-utils-u">320/1000</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">排放水平</div>
          <div class="detail-utils-u">国6b、SULEV30、欧六d</div>
        </div>
      </div>
      <div class="detail-four-list">
        <div class="detail-four-item">
          <div class="img-box"><img src="/assets/product/engine/6Z30/6Z30-1.jpg" alt=""></div>
        </div>
        <div class="detail-four-item">
          <div class="detail-four-title">GDI+PFI燃油双喷系统</div>
          <div class="detail-four-desc">
            采用GDI+PFI双喷系统，多形式油气雾化，涵盖范围广，PN排放最大降幅90%；GDI喷射压力350bar、PFI喷射压力5.5bar。
          </div>
        </div>
        <div class="detail-four-item">
          <div class="detail-four-title">双VGT增压器</div>
          <div class="detail-four-desc">
            全新开发VGT专用混流涡轮，流量增大12％；<br />
            980℃耐温+S型导流喷嘴环叶片，涡轮最高效率达73%；<br />
            开发专属非线性VGT增压控制及微量修正模型、喷嘴环自清洁控制逻辑，发挥增压器最大潜能。
          </div>
        </div>
        <div class="detail-four-item">
          <div class="img-box"><img src="/assets/product/engine/6Z30/6Z30-2.jpg" alt=""></div>
        </div>
      </div>
    </div>
    <div class="detail-box detail-bottom-bgs">
      <!-- <div class="detail-title">低油耗</div>
					<div class="detail-desc">200 g/kW.h燃油消耗率，创造省油新高度</div> -->
      <div class="detail-updown-list">
        <div class="detail-updown-item">
          <div class="detail-updown-title">多功能进气系统</div>
          <div class="detail-updown-desc">
            双电子节气门+进气歧管集成水冷中冷+进气消声解构，相对常规设计，进气管路缩短40%，压损降低60%，1500rpm定速加载时间缩短0.6s；<br />
            进气歧管集成水冷式中冷，压后温度由170℃降低至50℃以下，冷却效率93%；<br />
            匹配不等容积宽频消声腔，在1000-3000Hz范围内，消声能力≥25dB。</div>
          <div class="img-box"><img src="/assets/product/engine/6Z30/6Z30-3.jpg" alt=""></div>
        </div>
        <div class="detail-updown-item">
          <div class="detail-updown-title">双排链配气正时</div>
          <div class="detail-updown-desc">
            中置OCV，支持进、排气四路全可变VVT技术；<br />
            动导轨内侧布置，空间更紧凑；<br />
            超静音齿形链 + 错齿链轮 + 保压张紧器。</div>
          <div class="img-box"><img src="/assets/product/engine/6Z30/6Z30-4.jpg" alt=""></div>
        </div>
      </div>
    </div>

  </div>
  <Footer></Footer>
</template>

<script setup>
import { ref, nextTick, onMounted } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
const swiperInstances = ref({});

onMounted(() => {
  nextTick(() => {
    const swiperContainers = document.querySelectorAll('.swiper-container');

    swiperContainers.forEach((container, index) => {
      const containerKey = `swiper_${index}`;
      container.dataset.swiperKey = containerKey;
      const swiperInstance = new Swiper(container, {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 300,
        preventClicks: true,
        effect: 'fade',
      });
      swiperInstances.value[containerKey] = swiperInstance;
    });

    bindTabClickEvent();
  });
});
function bindTabClickEvent() {
  const allSwiperLists = document.querySelectorAll('.detail-swiper-list');

  allSwiperLists.forEach((swiperList) => {
    const tabItems = swiperList.querySelectorAll('.detail-tab-item');
    const targetSwiperContainer = swiperList.querySelector('.swiper-container');

    if (!tabItems.length || !targetSwiperContainer) return;

    const containerKey = targetSwiperContainer.dataset.swiperKey;
    const targetSwiper = swiperInstances.value[containerKey];
    if (!targetSwiper) return;

    const handleTabAction = (tabItem, localTabIndex) => {
      tabItems.forEach(item => item.classList.remove('active'));
      tabItem.classList.add('active');
      targetSwiper.slideTo(localTabIndex, 300, true);
    };
    tabItems.forEach((tabItem, localTabIndex) => {
      const handleTabClickWrapper = () => {
        handleTabAction(tabItem, localTabIndex);
      };
      tabItem.removeEventListener('click', handleTabClickWrapper);
      tabItem.removeEventListener('mouseenter', handleTabClickWrapper);
      tabItem.addEventListener('click', handleTabClickWrapper);
      tabItem.addEventListener('mouseenter', handleTabClickWrapper);
    });
  });
}
</script>

<script>
export const pageConfig = {
  title: '6Z30 双涡轮增压V型6缸发动机 - 蜂巢汽车官网',
  keywords: '蜂巢,蜂巢汽车,发动机,变速箱,电子',
  description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
  outputPath: 'engine/6Z30.html'
};

import { createApp } from 'vue';
import App from './6Z30.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"
import "@/assets/styles/product-details.scss"

function mountApp() {
  const appNode = document.getElementById('app');
  if (appNode) {
    if (appNode._vueApp) {
      appNode._vueApp.unmount();
      delete appNode._vueApp;
    }
    const app = createApp(App);
    app.use(store);
    appNode._vueApp = app.mount(appNode);
  }
}

// 页面加载完成后挂载
document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
  module.hot.accept('./6Z30.vue', () => {
    mountApp();
  });
}
</script>

<style lang="scss" scoped></style>